import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/_layout/$owner/settings/review')({
  beforeLoad: ({ params: { owner } }) => {
    // Redirect old review route to new agents route
    throw redirect({ to: '/$owner/settings/agents', params: { owner } });
  },
});
